import { render, staticRenderFns } from "./FleetEdit.vue?vue&type=template&id=bf4d1b0c&"
import script from "./FleetEdit.vue?vue&type=script&lang=js&"
export * from "./FleetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports